import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Breadcrump from "../../Components/Breadcrump";
import termsandconditionApi from "../../api/termsandconditionApi";
import { extractCmsDescription } from "../../utils/cmsUtils";

function TermsofServices() {
  const location = useLocation();
  const path = location.pathname.split("/")[1];

  const [metaData, setMetaData] = useState({});
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    fetchCMSDetails();
  }, []);

const fetchCMSDetails = async () => {
  try {
    const res = await termsandconditionApi.details();

    if (res.code === 200) {
      setTitle("Terms & Conditions");
      setDescription(extractCmsDescription(res.data, "terms-condition"));
    }
  } catch (err) {
    console.error("Terms & Conditions API Error:", err);
  }
};

  return (
    <>

      <Breadcrump title={"Terms & Condition"} />

      <section className="terms-condition py-5">
        <div className="container">
          <div className="content text-dark">
  {description ? (
    <div
      dangerouslySetInnerHTML={{ __html: description }}
      style={{ color: "#000", fontSize: "16px" }}
    />
  ) : (
    <p>Loading...</p>
  )}
</div>
        </div>
      </section>
    </>
  );
}

export default TermsofServices;
